import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction, warning } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import Row from '../grid';
import Pagination from '../pagination';
import Spin from '../spin';
export default {
  name: buildComponentName('List'),
  provide: function provide() {
    return {
      listRoot: this
    };
  },
  inheritAttrs: false,
  props: {
    prefixCls: {
      type: String,
      default: 'ux-list'
    },
    dataSource: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    renderItem: {
      type: Function,
      default: null
    },
    bordered: {
      type: Boolean,
      default: false
    },
    grid: {
      type: Object,
      default: null
    },
    itemLayout: {
      type: String,
      default: '',
      validator: function validator(val) {
        return ['vertical', ''].indexOf(val) > -1;
      }
    },
    loading: {
      type: [Boolean, Object],
      default: false
    },
    pagination: {
      type: [Boolean, Object],
      default: false
    },
    // rowKey: {
    //   type: [String, Function],
    //   default: 'key',
    // },
    size: {
      type: String,
      default: '',
      validator: function validator(val) {
        return ['small', 'default', 'large', ''].indexOf(val) > -1;
      }
    },
    split: {
      type: Boolean,
      default: true
    },
    header: {
      type: String,
      default: ''
    },
    footer: {
      type: String,
      default: ''
    },
    emptyText: {
      type: String,
      default: '暂无数据'
    }
  },
  data: function data() {
    return {
      innerPager: {}
    };
  },
  computed: {
    spinProps: function spinProps() {
      var loading = this.loading;
      return typeof loading === 'boolean' ? {
        spinning: loading
      } : loading;
    },
    isLoading: function isLoading() {
      var spinProps = this.spinProps;
      return !!spinProps.spinning;
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          split = this.split,
          bordered = this.bordered,
          size = this.size,
          grid = this.grid,
          itemLayout = this.itemLayout,
          isLoading = this.isLoading;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-split"), split), _defineProperty(_ref, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_ref, "".concat(prefixCls, "-").concat(size === 'large' ? 'lg' : 'sm'), size === 'large' || size === 'small'), _defineProperty(_ref, "".concat(prefixCls, "-grid"), !!grid), _defineProperty(_ref, "".concat(prefixCls, "-vertical"), itemLayout === 'vertical'), _defineProperty(_ref, "".concat(prefixCls, "-loading"), isLoading), _ref;
    },
    hasPagination: function hasPagination() {
      return !!this.pagination;
    },
    normalizeData: function normalizeData() {
      var dataSource = this.dataSource,
          hasPagination = this.hasPagination,
          _this$innerPager = this.innerPager,
          current = _this$innerPager.current,
          pageSize = _this$innerPager.pageSize;
      var data = dataSource;

      if (hasPagination && data.length > pageSize) {
        data = data.slice((current - 1) * pageSize, current * pageSize);
      }

      return data;
    },
    pagerElement: function pagerElement() {
      return this.renderPagination();
    }
  },
  watch: {
    pagination: {
      handler: function handler() {
        this.initPager();
      },
      deep: true
    },
    dataSource: function dataSource() {
      this.initPager();
    }
  },
  created: function created() {
    this.initPager();
  },
  methods: {
    setInnerPager: function setInnerPager(pager) {
      this.innerPager = pager;
    },
    resetPagerCurrent: function resetPagerCurrent() {
      var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var total = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
      var max = Math.floor((total - 1) / pageSize) + 1;
      return Math.max(Math.min(current, max), 1);
    },
    onPaginationChange: function onPaginationChange(current, pageSize) {
      var onChange = this.pagination.onChange,
          innerPager = this.innerPager,
          setInnerPager = this.setInnerPager;
      setInnerPager(_objectSpread({}, innerPager, {
        current: current
      }));

      if (isFunction(onChange)) {
        onChange(current, pageSize);
      }

      this.$emit('pagination-change', current, pageSize);
    },
    initPager: function initPager() {
      var innerPager = this.innerPager,
          size = this.size,
          hasPagination = this.hasPagination,
          pagination = this.pagination,
          dataSource = this.dataSource,
          onPaginationChange = this.onPaginationChange,
          setInnerPager = this.setInnerPager,
          resetPagerCurrent = this.resetPagerCurrent;

      if (!hasPagination) {
        return;
      }

      var pager = {
        size: size === 'small' ? size : '',
        current: 1,
        pageSize: 10,
        position: 'bottom'
      };
      pager = _objectSpread({}, pager, {}, innerPager);

      if (typeof pagination !== 'boolean') {
        pager = _objectSpread({}, pager, {}, pagination);
      }

      pager.total = dataSource.length;
      pager.current = resetPagerCurrent(pager.current, pager.total, pager.pageSize);
      pager.on = {
        change: onPaginationChange
      };
      setInnerPager(pager);
    },
    getGridPropVal: function getGridPropVal(propName) {
      var grid = this.grid;

      if (!grid || !grid[propName]) {
        return undefined;
      }

      return Math.floor(24 / grid[propName]);
    },
    renderEmptyText: function renderEmptyText() {
      var h = this.$createElement;
      var slotEmptyText = this.$slots.emptyText,
          prefixCls = this.prefixCls,
          emptyText = this.emptyText;
      return h("div", {
        "class": "".concat(prefixCls, "-empty-text")
      }, [slotEmptyText || emptyText]);
    },
    renderPagination: function renderPagination() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          hasPagination = this.hasPagination,
          innerPager = this.innerPager;
      var pager = {
        top: null,
        bottom: null
      };

      if (!hasPagination) {
        return pager;
      }

      var position = innerPager.position,
          on = innerPager.on,
          pagerProps = _objectWithoutProperties(innerPager, ["position", "on"]);

      var pos = [];

      if (position === 'both') {
        pos.push('top', 'bottom');
      } else {
        pos.push(position === 'top' ? 'top' : 'bottom');
      }

      pos.forEach(function (p) {
        pager[p] = h("div", {
          "class": "".concat(prefixCls, "-pagination")
        }, [h(Pagination, {
          "props": _objectSpread({}, pagerProps),
          "on": _objectSpread({}, on)
        })]);
      });
      return pager;
    },
    renderChildren: function renderChildren() {
      var h = this.$createElement;
      var $scopedSlots = this.$scopedSlots,
          grid = this.grid,
          renderItem = this.renderItem,
          normalizeData = this.normalizeData,
          getGridPropVal = this.getGridPropVal;
      var renderFn = $scopedSlots.renderItem || renderItem;

      if (!isFunction(renderFn)) {
        if (process.env.NODE_ENV !== 'production') {
          warning(false, 'you need to provide the renderItem slot-scope or render-item prop');
        }

        return null;
      }

      if (normalizeData.length > 0) {
        var gridProp = grid ? {
          span: getGridPropVal('column'),
          xs: getGridPropVal('xs'),
          sm: getGridPropVal('sm'),
          md: getGridPropVal('md'),
          lg: getGridPropVal('lg'),
          xl: getGridPropVal('xl')
        } : null;
        return normalizeData.map(function (item, index) {
          var content = renderFn({
            item: item,
            index: index
          });
          return grid ? h(Row.Col, {
            "props": _objectSpread({}, gridProp)
          }, [content]) : content;
        });
      }

      return null;
    }
  },
  render: function render() {
    var h = arguments[0];
    var $attrs = this.$attrs,
        _this$$slots = this.$slots,
        slotHeader = _this$$slots.header,
        slotDefault = _this$$slots.default,
        slotFooter = _this$$slots.footer,
        slotLoadMore = _this$$slots.loadMore,
        prefixCls = this.prefixCls,
        classes = this.classes,
        pagerElement = this.pagerElement,
        grid = this.grid,
        spinProps = this.spinProps,
        isLoading = this.isLoading,
        header = this.header,
        footer = this.footer,
        renderChildren = this.renderChildren,
        renderEmptyText = this.renderEmptyText;
    var headerElement = slotHeader || header;
    var footerElement = slotFooter || footer;
    var childrenElement = renderChildren();

    if (childrenElement) {
      childrenElement = grid ? h(Row, {
        "attrs": {
          "gutter": grid.gutter
        }
      }, [childrenElement]) : childrenElement;
    } else if (!isLoading) {
      childrenElement = renderEmptyText();
    }

    return h("div", _mergeJSXProps2([{}, {
      class: [classes, _defineProperty({}, "".concat(prefixCls, "-something-after-last-item"), !!(slotLoadMore || pagerElement.bottom || footerElement))],
      attrs: $attrs
    }]), [pagerElement.top, headerElement ? h("div", {
      "class": "".concat(prefixCls, "-header")
    }, [headerElement]) : null, h(Spin, _mergeJSXProps([{}, {
      style: 'width:100%',
      props: spinProps
    }]), [childrenElement, slotDefault]), footerElement ? h("div", {
      "class": "".concat(prefixCls, "-footer")
    }, [footerElement]) : null, slotLoadMore || pagerElement.bottom]);
  }
};